<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

<!--        <vs-divider class="mt-8 mb-12" color="primary" position="center">Genaral Informations</vs-divider>-->

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 w-full md:mb-0">
            <ValidationProvider vid="no_employees" name="no_employees" rules="required" v-slot="{ errors }">
              <small class="label">3.1 No. of Employees</small>
              <vs-input type="number" name="no_employees" class="w-full" v-model="form.no_employees" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/3 w-full md:mb-0">
            <ValidationProvider vid="age_site" name="age_site" rules="required" v-slot="{ errors }">
              <small class="label">3.2 Age of site (years)</small>
              <vs-input type="text" name="age_site" class="w-full"  v-model="form.age_site" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>

        <div class="flex flex-wrap items-center justify-end">
          <vs-button v-if="status.is_supplier_manufacture_site_site_complete === 1"  button="submit" class="ml-auto mt-2">Save and Change</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4">Save and Change</vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

    export default {
        name: "SupplierManufacturingHome",
      data() {
          return {
            form: {},
            id: null,
            status: {}
          }
      },
      mixins: [SuccessMessage, ErrorMessages],
      methods: {
        onClickNext() {
          this.$emit('notify', 1)
        },
        onClickSubmit() {
          this.status.is_supplier_manufacture_site_site_complete === 1 ? this.onClickUpdate() : this.onClickCreate()
        },

        async onClickUpdate() {
          this.$vs.loading()
          try {
            const data= (await SupplierManufactureRepository.UpdateManufactureSiteDetails(this.id, this.form))
            this.showSuccessMessage('Manufacture Site Details Updated!')
            this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        },
        async onClickCreate() {
          this.$vs.loading()
          try {
            const data= (await SupplierManufactureRepository.CreateManufactureSiteDetails(this.form))
            this.showSuccessMessage('Manufacture Site Details Created!')
            this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        },

        async loadData() {
          this.$vs.loading()
          const {data} = (await SupplierManufactureRepository.getManufactureSiteDetails(this.id)).data
          this.form =data
          this.$vs.loading.close()
        },
        async loadStatus() {
          this.$vs.loading()
          const {data} = (await SupplierManufactureRepository.getManufactureSiteStatus(this.id)).data
          this.status =data
          this.$vs.loading.close()
        }
      },
      async mounted() {
        this.id = this.$route.params.id
        this.form.supplier_manufacture_site_id =  this.id
        await this.loadStatus()
        if (this.status.is_supplier_manufacture_site_site_complete === 1 ) {
          await this.loadData()
        }
      }
    }
</script>

<style scoped>

</style>
